module.exports = __webpack_public_path__ + "img/preview-roadmap.cdf7ab96.png";